(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-blog-posts"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const searchInput = document.getElementById('blog-search-input');
  const sortSelect = document.getElementById('blog-sort-select');
  const blogGrid = document.getElementById('blog-grid');

  function filterPosts() {
    const query = searchInput.value.toLowerCase();
    const items = blogGrid.querySelectorAll('.blog-item');
    items.forEach(item => {
      const title = item.querySelector('.blog-title-text').textContent.toLowerCase();
      item.style.display = title.includes(query) ? '' : 'none';
    });
  }

  function sortPosts() {
    const items = Array.from(blogGrid.querySelectorAll('.blog-item'));
    if (sortSelect.value === 'newest') {
      items.sort((a, b) => new Date(b.dataset.date) - new Date(a.dataset.date));
    } else if (sortSelect.value === 'oldest') {
      items.sort((a, b) => new Date(a.dataset.date) - new Date(b.dataset.date));
    }
    items.forEach(item => blogGrid.appendChild(item));
  }

  searchInput?.addEventListener('input', filterPosts);
  sortSelect?.addEventListener('change', sortPosts);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
